import React, { useContext } from 'react';
import AuthContext from 'context/AuthContext';
import userAvatar from '../../../assets/images/userAvatar.png';

import { useTranslation } from 'react-i18next';
import OImage from 'components/reusable/OImage';
import dayjs from 'dayjs';

function BasicInfo({ items }) {
  const { defaultCurrency, config } = useContext(AuthContext);
  const { t } = useTranslation();
  return (
    <>
      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
        <tbody>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('O_TITLE')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.title || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('O_TITLE') + t('O_ARABIC')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.titleAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('O_SUBTITLE')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.sub_title || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('O_SUBTITLE') + t('O_ARABIC')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.sub_titleAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Slug
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.slug || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Slug(Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.slugAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('STATIC_TITLE')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaTitle || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('STATIC_TITLE') + t('O_ARABIC')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaTitleAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('STATIC_DESCRIPTION')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaDescription || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('STATIC_DESCRIPTION') + t('O_ARABIC')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaDescriptionAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('KEYWORD')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.keyword || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('KEYWORD') + t('O_ARABIC')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.keywordAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('O_STARTING_PRICE')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.startingPrice > 0
                ? `${items?.startingPrice} ( ${defaultCurrency} )`
                : 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('DELIVERY_DATE')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.handOverDate
                ? dayjs(items?.handOverDate).format('MMMM D, YYYY')
                : 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('PROJECT_STATUS')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.projectStatus || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('PROJECT_TYPE')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.projectType || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('DEVELOPER_NAME')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.developerName || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('DEVELOPER_NAME') + t('O_ARABIC')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.developerNameAr || 'N/A'}
            </th>
          </tr>

          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('PRICE_PER_SQFT')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.pricePerSqFt > 0
                ? `${items?.pricePerSqFt} ( ${defaultCurrency} )`
                : 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('PAYMENT_PERCENTAGE')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              <div className="flex">
                <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 border-l-2 border-[#E1E6EE]">
                  <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="py-3 px-6 text-center">
                        Title
                      </th>
                      <th scope="col" className="py-3 px-6 text-center">
                        Percentage
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {items?.paymentPercent &&
                      items?.paymentPercent?.map((item, i) => (
                        <tr
                          key={i}
                          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                        >
                          <th
                            scope="row"
                            className="py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white"
                          >
                            {item?.paymentTitle || 'N/A'}
                          </th>
                          <th
                            scope="row"
                            className="py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white"
                          >
                            {item?.percentage || 'N/A'}
                          </th>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('BEDROOMS') +
                ' (' +
                t('O_MINIMUM') +
                ' - ' +
                t('O_MAXIMUM') +
                ')'}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {`${items?.minBedrooms ?? 'N/A'} - ${
                items?.maxBedrooms ?? 'N/A'
              }`}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('BATHROOMS') +
                ' (' +
                t('O_MINIMUM') +
                ' - ' +
                t('O_MAXIMUM') +
                ')'}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {`${items?.minBathrooms ?? 'N/A'} - ${
                items?.maxBathrooms ?? 'N/A'
              }`}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('GUEST_ROOMS') +
                ' (' +
                t('O_MINIMUM') +
                ' - ' +
                t('O_MAXIMUM') +
                ')'}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {`${items?.minGuestRooms ?? 'N/A'} - ${
                items?.maxGuestRooms ?? 'N/A'
              }`}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('O_PROPERTY_SIZE') +
                ' (' +
                t('O_MINIMUM') +
                ' - ' +
                t('O_MAXIMUM') +
                ')'}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {`${items?.minPropertySize ?? 'N/A'} - ${
                items?.maxPropertySize ?? 'N/A'
              } (${config?.areaUnit})`}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('LIVING_ROOMS') +
                ' (' +
                t('O_MINIMUM') +
                ' - ' +
                t('O_MAXIMUM') +
                ')'}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {`${items?.minLivingRooms ?? 'N/A'} - ${
                items?.maxLivingRooms ?? 'N/A'
              }`}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Description
            </th>
            <th
              scope="row"
              dangerouslySetInnerHTML={{ __html: items?.description }}
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            />
            {/* {items?.description}
            </th> */}
          </tr>

          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Description (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.descriptionAr}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Account Name
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.accountName || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Account Name (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.accountNameAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Bank Name
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.bankName || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Bank Name (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.bankNameAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              IBAN
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.iban || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Down Payment Percentage
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {`${items?.downPaymentPercentage || 0}%` || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              colSpan={2}
              className="py-2 px-2 border-r font-semibold text-gray-900 dark:text-white"
            >
              Freelancer Asset Access
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Show Brochure
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.showBrochureToFreelancer ? 'Yes' : 'No'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Show Floor Plan
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.showFloorPlanToFreelancer ? 'Yes' : 'No'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Show Payment Plan
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.showPaymentPlanToFreelancer ? 'Yes' : 'No'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Show EDM
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.showEdmToFreelancer ? 'Yes' : 'No'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Show Art Gallery
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.showArtGalleryToFreelancer ? 'Yes' : 'No'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Show Video
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.showVideoToFreelancer ? 'Yes' : 'No'}
            </th>
          </tr>
        </tbody>
      </table>
      <div className="photos">
        <div className="text-50px font-medium text-lg p-6 pb-0">
          Developer Image
        </div>
        <div className="images-container pl-6 pr-4 flex flex-wrap">
          {items.developerImage ? (
            <div className="item object-cover w-24 h-24 border overflow-hidden  m-2">
              <OImage
                src={items?.developerImage ?? userAvatar}
                fallbackUrl={userAvatar}
                className="object-cover w-24 h-24"
              />

              {/* <img src={items?.developerImage} alt='' className='object-cover w-24 h-24' /> */}
            </div>
          ) : (
            'No photo found'
          )}
        </div>
      </div>
    </>
  );
}

export default BasicInfo;
